import { CellContext } from "@tanstack/react-table";
import type { ViewTableFeatures } from "@design-system/ViewTable/core/table";
import { memo, useCallback } from "react";
import { Entity } from "@common/types/entity";
import { ViewTableCell } from "@design-system/ViewTable/ViewTableCell";
import { EntityAvatarGroup } from "@components/avatar/EntityAvatarGroup";
import { BillsByCounterpartyItem } from "@common/types/bill";
import { useEntitiesById } from "@hooks/useEntities";

export const EntitiesCell = memo(
    ({ row }: CellContext<ViewTableFeatures, BillsByCounterpartyItem, any>) => {
        const item = row.original;
        const entities = useEntitiesById();

        const getEntities = useCallback(
            (entityIds: number[]) =>
                entityIds.map((entityId) => entities.get(entityId) as Entity),
            [entities],
        );

        return (
            <ViewTableCell>
                <EntityAvatarGroup
                    entities={getEntities(item.entityIds)}
                    max={3}
                />
            </ViewTableCell>
        );
    },
);
